import { useEffect, useState } from "react"
import { private_server } from "../../../../../config"
import { isFormValid, onGetCatalogs, onGetErrorMessage, onGetFormData, onInitForm, onSetErrorsToForm, updateAuthorizationHeader } from "../../../../../shared/utility"
import { generic_errors } from "../../../../../texts/esp/genericErrors"
import useProduct from "../../../../../hooks/api/useProduct"


const useAddProductToPGModal = ({open, content, onClose, language, onCompleted, id}) => {

    
    const productManager = useProduct()

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [loading_prod, setLoadingProd] = useState(false)
    const [error, setError] = useState(null)
    const [form, setForm] = useState(JSON.parse(JSON.stringify(form_data)))

    const [product_selected, setProductSelected] = useState(null);
    const [options, setOptions] = useState([])

    const [search, setSearch] = useState(null)

    //console.log(id)

    useEffect(() => {
        if(!open){
            setError(null)
            setForm(JSON.parse(JSON.stringify(form_data)))
            //actions.onInitModule()
        }
    }, [open])

    let prod_form = {...form.id_product}
    prod_form.options = [...options]
    
    const actions = {
        onInitModule: async() => {
            /* try{
                setLoading(true)
                const products = await private_server.get(`product/all?&filter={"AND":[{"field":"purchase_group_id","operator":"!=","value":"${id}"}]}`)
                //console.log(products)
                let _form = onInitForm(form_data, null, content.form)
                _form.id_product.options = onGetCatalogs(products.data.data.products, 'id_product', 'name')
                setForm(_form)
            }catch(error){
                const _error = onGetErrorMessage(error, language)
                setError(_error ? _error.message : null)
            }
            setLoading(false) */
            
        },
        onChangeForm: (data) => {
            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data }
            if(error) setError(null)
            setForm(temp)
        },
        onInputChange: (e) =>{
            //if(!e || e.target.value === "" || e.target.value === 0) return
            setSearch(e)
        },
        onSearchProduct: async(e) => {
            //if(!e || e.target.value === "" || e.target.value === 0) return
            if(error) setError(null)
            setLoadingProd(true)
            try {

                if(!search){
                    const params = {limit:30 }
                    const filter = {filter:
                        {"OR":[
                            {"field":"name","operator":"LIKE","value":`%${search}%`},
                            {"field":"code","operator":"LIKE","value":`%${search}%`},
                            {"field":"brand","operator":"LIKE","value":`%${search}%`},
                            {"field":"description","operator":"LIKE","value":`%${search}%`},
                        ]}           
                    }
                    const req = await private_server.get(`/product/all`, {params:{...params, ...filter}})
                    const cat = req.data.data.products.map(item => 
                        {return {value: item.id_product, label: item.code + ' - ' + item.brand + ' - ' + item.name, brand:item.brand, code:item.code, name:item.name}})
                    setOptions(cat)
                }else{
                    const params = {limit:30, search:search}
                    const _productdata = await productManager.onSearch(params)
                    const cat = _productdata.data.map(item => 
                        {return {value: item.id_product, label: item.code + ' - ' + item.brand + ' - ' + item.name, brand:item.brand, code:item.code, name:item.name}})
                    setOptions(cat)
                }


            } catch (error) {
                console.log(error)
            }
            setLoadingProd(false)
        },
        onChangeProduct: async (item) =>{
            if(item){
                //console.log(item.value)
                setProductSelected(item.value)
            }
        },
        onSubmit: async() => {
            /* const errors = isFormValid(form)

            // Error handler
            if(errors && errors.length){
                const _form = onSetErrorsToForm(form, errors)
                setForm(_form)
                setError(generic_errors[language].INCOMPLETE_FORM)
                return
            }

            // Clean data
            const data2send = onGetFormData(form)
            console.log(data2send) */

            try {
                setSending(true)
                updateAuthorizationHeader(private_server)
                await private_server.patch(`/product/${product_selected}`, {purchase_group_id:id})
                onCompleted()
                setError(null)
                setSending(false)
                onClose()
            } catch (error) {
                setSending(false)
                const _error = onGetErrorMessage(error, language)
                if(_error.details){
                    console.log('Actualizar datos')
                    const _error_keys = Object.keys(_error.details).map(item => item)
                    const _form = onSetErrorsToForm(form, _error_keys)
                    console.log(_form)
                    setForm(_form)
                }
                setError(_error ? _error.message : null)
            }
            
        }
    }

    return {loading, sending, error, form, actions, prod_form, options, product_selected, loading_prod, search} 
}


export default useAddProductToPGModal

const form_data = {
    id_product: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[],
        config: {
            id: 'id_product',
            type: 'select',
            fullWidth: true,
        },
        rules: {type: 'select'}
    },
  

}